/** W82: Formen der Blasen des Geists (Blase.tsx) und die Teile seiner Sätze. */
/** Ein Teil eines Satzes des Geists; Signalwörter tragen ihre Zustandsfarbe mit Unterstrich (Signalwort-Regel). */
export type SatzTeil = { text: string; signal?: "ueberfaellig" | "erledigt"; betont?: boolean };
export type BlasenForm = "kopf" | "unterwegs" | "rand" | "titel";

/** Spitzen-Regel: genau eine kleine Ecke von 8 px, sie zeigt auf die Figur; jede Bewegung wächst aus ihr. */
export const BLASEN_FORM: Record<BlasenForm, { spitze: "unten-links" | "unten-rechts" | "oben-links" | "oben-rechts"; ursprung: string; schwebend: boolean; stufe: string }> = {
  kopf: { spitze: "unten-links", ursprung: "0% 100%", schwebend: false, stufe: "w-satz-geist" },
  unterwegs: { spitze: "unten-rechts", ursprung: "100% 100%", schwebend: true, stufe: "w-satz-unterwegs" },
  rand: { spitze: "oben-links", ursprung: "0% 0%", schwebend: true, stufe: "w-satz-rand" },
  /** W82 Web-5b (K32): unter dem Geist der Titelzeile (Reiter Fristen), die Spitze oben rechts zu ihm */
  titel: { spitze: "oben-rechts", ursprung: "100% 0%", schwebend: true, stufe: "w-satz-rand" },
};

